module.exports = __webpack_public_path__ + "media/newstyle/images/heart_plus-b223cb9eba02dacc6841cd4e1fd75503.svg";